import { useState } from 'react';
import { useAuthStore } from '../services/auth';

const LogoutPage = () => {
    const logout = useAuthStore((state) => state.logout);
    const [isLogout, setIsLogout] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        logout();
        setIsLogout(true);
    }

    return (
        <div>
            {isLogout? (
                <p>loged out</p>
            ): (
                <button className='add-button' type="submit" onClick={handleSubmit}>
                    <span>Logout</span>
                </button>
            )}
        </div>
    )
}

export default LogoutPage